import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import {MenuOption, Container} from './style'
// Assets
import {ReactComponent as ExpandMore} from 'images/icons/expanse.svg'
import ListItem from '../listItem'
import { ReactComponent as DashboardIcon } from 'images/icons/dashboard.svg'
import { useLocation } from 'react-router'
import { useSelector } from 'react-redux'

const DashOption = props => {
	const dashAvailable = [{
		active: true,
		label: props?.t?.analytics?.assistanceAnalysis ?? "Analítico Atendimento",
		to: 'analitico-atendimento'
	},{
		active: true,
		label: props?.t?.analytics?.campaignAnalysis ?? "Analítico Campanha",
		to: 'analitico-campanha'
	},{
		active: true,
		label: props?.t?.analytics?.logsAnalysis ?? "Analítico Logs",
		to: 'analitico-logs'
	},{
		active: true,
		label: props?.t?.analytics?.monitoringAnalysis ?? "Analítico Monitoria",
		to: 'analitico-monitoria'
	},{
		active: true,
		label: props?.t?.analytics?.incidentAnalysis ?? "Analítico Ocorrência",
		to: 'analitico-ocorrencia'
	},{
		active: true,
		label: props?.t?.analytics?.surveyAnalysis ?? "Analítico Pesquisa",
		to: 'analitico-pesquisa'
	},{
		active: true,
		label: props?.t?.analytics?.ticketAnalysis ?? "Analítico Ticket",
		to: 'analitico-ticket'
	},{
		active: true,
		label: props?.t?.analytics?.transferAnalysis ?? "Analítico Transferências",
		to: 'analitico-transferencia'
	},{
		active: true,
		label: props?.t?.analytics?.watsonAnalysis ?? "Analítico Watson",
		to: 'analitico-watson'
	},{
		active: true,
		label: props?.t?.analytics?.serviceDashboard ?? "Dashboard de Atendimentos",
		to: 'dashboard-atendimento'
	},{
		active: true,
		label: props?.t?.analytics?.monitoringAudit ?? "Monitoria / Auditoria",
		to: 'monitoria-auditoria'
	},
	{
		active: true,
		label: props?.t?.analytics?.customReports ?? "Relatórios Personalizados",
		to: 'relatorios-personalizados'
	}]

	const location = useLocation()
	const [open, setOpen] = useState(false)

	const isPath = (path) => {
		let pathSplit = location.pathname.split('/').filter(x => x.length > 0)
		return Array.isArray(pathSplit) && pathSplit.length > 0 && pathSplit[0] === path
	}

	useEffect(() => {
		setOpen(false)
	}, [location.pathname])

	return <ClickAwayListener onClickAway={() => setOpen(false)}>
		<Container>
			<ListItem className={classNames({open}, 'dashboard-menu')} active={dashAvailable.find(({to}) => isPath(to))} onClick={() => setOpen(prevState => !prevState)}>
				<DashboardIcon />
				<p>{props.t.dashboard}</p>
				<ExpandMore/>
			</ListItem>
			<MenuOption className={classNames({hidden: !open})}>
				{dashAvailable.filter(({active}) => active).map(({ to, label }) =>
					<ListItem to={`/${to}`} key={`dashboard-${to}`} className={classNames({
						active: isPath(to)
					}, 'dashboard')}>{label}</ListItem>
				)}
			</MenuOption>
		</Container>
	</ClickAwayListener>
}

export default DashOption